document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    var timestamp = localStorage.getItem("timestamp");
    var currentTimestamp = new Date().getTime() / 1000; // Current time in seconds

    function showTrustpilotPopup() {
      var trustpilotPopup = document.getElementById("shopify-section-trustpilot-popup");
      if(trustpilotPopup) {
        trustpilotPopup.style.display = "block";
      }
    }

    function hideTrustpilotPopup() {
      var trustpilotPopup = document.getElementById("shopify-section-trustpilot-popup");
      if(trustpilotPopup) {
        trustpilotPopup.style.display = "none";
      }
    }

    function showTrustpilotReviews() {
      var trustpilotReviews = document.querySelector("product-info > #trustpilot-reviews");
      if(trustpilotReviews) {
        trustpilotReviews.style.display = "block";
      }
    }

    function hideTrustpilotReviews() {
      var trustpilotReviews = document.querySelector("product-info > #trustpilot-reviews");
      if (trustpilotReviews) {
        trustpilotReviews.style.display = "none";
      }
    }

    if (timestamp !== null) {
      var epochGap = 900; // 900 seconds = 15 minutes
      var jsTimestamp = new Date(parseInt(timestamp)).getTime() / 1000;
      var timeDifference = currentTimestamp - jsTimestamp;

      if (timeDifference > epochGap) {
        console.log(
          "Returning visitor detected, visiting after the specified gap"
        );
        hideTrustpilotPopup();
        showTrustpilotReviews();
      } else {
        console.log("Visitor is returning but within the specified gap");
        hideTrustpilotReviews();
      }
    } else {
      console.log("First-time visitor detected");
      showTrustpilotPopup();
      hideTrustpilotReviews();
      localStorage.setItem("timestamp", new Date().getTime());
    }
  }, 1000);
});
